import "./EditMap.html";
import "./EditMap.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditMapComponentController from "./EditMapComponentController";

export default class EditMapComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            map: "<",
            mapChanged: "&?",
            siteId: "<",
        };
        this.controller = EditMapComponentController;
        this.templateUrl = "/App/Components/Site/DesignAndPlanning/EditMap/EditMap.html";
    }
}

module("mmManagePortal").component("mmEditMap", new EditMapComponent());
